/**
 * Archive “stash” adapted from https://iconimate.app/r/archive.json
 * Version 582bfd935626. CSS playback is triggered by the parent button's hover.
 * Animation copyright (c) 2026 Muhammad Ammar (smammar100).
 * Glyph copyright (c) 2023 Phosphor Icons.
 *
 * MIT License
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import IconBase from '@phosphor-icons/react/dist/lib/IconBase'
import type { IconWeight } from '@phosphor-icons/react'
import type { ReactElement } from 'react'

const weights = new Map<IconWeight, ReactElement>([['regular', <>
  <path className="archive-icon-box" fillRule="evenodd" d="M32,104H224V192a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16ZM48,104H208V192H48Z" />
  <path className="archive-icon-label" d="M96,136a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,136Z" />
  <path className="archive-icon-lid" fillRule="evenodd" d="M32,48H224a16,16,0,0,1,16,16V88a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V64A16,16,0,0,1,32,48ZM32,64H224V88H32Z" />
</>]])

export function ArchiveIcon() {
  return <IconBase weights={weights} weight="regular" size={20} className="archive-icon" aria-hidden="true" focusable="false" />
}
